import { useWindowScrollPosition } from "@n8tb1t/use-scroll-position";

import classNames from "classnames";
import React from "react";
import HeaderMobileDialog from "./header-mobile-dialog";
import HeaderNavbar from "./header-navbar";

export interface HeaderProps {
  className?: string;
  mode: "hidden" | "default" | "floating";
}

export type NavState = {
  pinned: boolean;
  unpinned: boolean;
};

const triggerY = 500;

const Header = ({ className, mode }: HeaderProps) => {
  const [navState, setNavState] = React.useState<NavState>({
    pinned: false,
    unpinned: true,
  });

  useWindowScrollPosition(({ currPos }) => {
    const pinned = currPos.y >= triggerY;
    const top = currPos.y === 0;
    const bottom = currPos.y === 0;

    console.log(pinned, top, bottom);

    const newNavState = {
      pinned,
      unpinned: !pinned,
    };

    setNavState(newNavState);
  });

  return (
    <div className="header">
      {mode !== "hidden" && <HeaderNavbar />}
      <div
        className={classNames([
          "fixed w-full z-50 top-0 transition-transform",
          {
            "translate-y-0": navState.pinned,
            "-translate-y-full": navState.unpinned,
          },
          className,
        ])}
      >
        <HeaderNavbar />
      </div>
      <HeaderMobileDialog />
    </div>
  );
};

export default Header;
